import { twMerge } from 'tailwind-merge';

export function FooterLogoWrapper(props: { children: React.JSX.Element; className?: string }) {
  return (
    <div className={twMerge('flex h-full flex-col items-center justify-between', props.className)}>
      {props.children}
    </div>
  );
}
